// eslint-disable-next-line import/no-internal-modules
import { IdeationStatus } from '@insided/deprecated-services/unified'
import classNames from 'classnames'
import { FunctionalComponent } from 'preact'

export interface IdeationStatusViewProps {
  ideationStatus: IdeationStatus
}

const IdeationStatusView: FunctionalComponent<IdeationStatusViewProps> = ({ ideationStatus }) => (
  <span
    className={classNames(
      'topic__content-type-pill',
      'pill',
      'pill--uppercase',
      'pill--idea',
      'qa-content-type-pill'
    )}
    style={`background-color: ${ideationStatus.bgColor}; color: ${ideationStatus.color};`}
  >
    {ideationStatus.name}
  </span>
)

export default IdeationStatusView
